import api from "./api";

const TERMINAL_BASE = "/api/terminal";

const terminalApi = {
  getLiveLogs: (params = {}) =>
    api.get(`${TERMINAL_BASE}/live`, { params }).then((r) => r.data),

  getServerStats: () => api.get(`${TERMINAL_BASE}/stats`).then((r) => r.data),

  getLogFiles: () => api.get(`${TERMINAL_BASE}/logs/files`).then((r) => r.data),

  getFileLogs: (logType = "combined", lines = 100) =>
    api
      .get(`${TERMINAL_BASE}/logs`, { params: { logType, lines } })
      .then((r) => r.data),

  getEnvironmentInfo: () =>
    api.get(`${TERMINAL_BASE}/environment`).then((r) => r.data),

  /**
   * Returns the full SSE URL for the stream endpoint.
   * The component should use EventSource directly with auth token.
   */
  getStreamUrl: () => {
    const baseUrl = api.defaults.baseURL || "";
    return `${baseUrl}${TERMINAL_BASE}/stream`;
  },
};

export default terminalApi;
